module.exports = __webpack_public_path__ + "img/banner-perizinan.9ad161e9.jpg";